import NBType, { InferType } from '@netbase/nb-type'
import DashboardOwnerInfoSchema from './DashboardOwnerInfoSchema'
import DashboardType from '../enums/DashboardType'

const DashboardInfoSchema = NBType.object().shape('DashboardInfoSchema', {
  /* @prop */
  createDatetime: NBType.number(),
  /* @prop */
  id: NBType.number().defined(),
  /* @prop */
  labels: NBType.array().of(NBType.string().defined()),
  /* @prop */
  lastViewedDatetime: NBType.number().nullable(),
  /* @prop */
  liveReportEnabled: NBType.boolean(),
  /* @prop */
  scheduledReportEnabled: NBType.boolean(),
  /* @prop */
  name: NBType.string(),
  /* @prop */
  ownerInfo: DashboardOwnerInfoSchema,
  /* @prop */
  type: NBType.enum(DashboardType),
  /* @prop */
  updateDatetime: NBType.number()
  /* END */
})
export default DashboardInfoSchema
export type DashboardInfo = InferType<typeof DashboardInfoSchema>
// RESERVE BELOW
